<div class="vh_center mt-4">
  <div col="12">
      <div style=" margin:0px; " class="vh_center">
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
          <div style="width:130px; height:5px; background-color: #fcb816;"></div>
          <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
      </div>
  </div>
</div>
<div class="vh_center mt-2">
  <div col="12">
      <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
          <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
          <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order details</div>
          <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
          <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place order</div>
      </div>
  </div>
</div>
<div class="page_bottom_space">
    <div class="container border-0 mb-5">
        <div class="fs-2 fw-bolder text-center text-lgh-yellow pt-4 mb-2"> Thank you for your order!</div>
        <div class="text-center" *ngIf="!commonService.commonMainObj.orderPlacedData.pendingPaymentMessage">
            <!-- <div class="border fw-bolder text-danger mb-4" *ngIf="commonService.commonMainObj.pcbType == 'Standard PCB'" style="margin: 0px 5rem;">
                <p class="m-0 mt-3">We will proceed with procurement of line items that did not have any issues, </p>
                <p class="">but the order will be put on hold untill all BOM issues are fixed.</p>
            </div> -->
            <p class="mb-0" style="font-size: 1.1rem;">A confirmation of your order has been emailed to you. Your <span class="text-lgh-yellow">order number is <b> {{commonService.commonMainObj.orderPlacedData.orderNumber}}</b> 
              <!-- schedule to ship on <b>{{commonService.commonMainObj.orderPlacedData.promisedShipDate}}</b> -->
            </span></p>
            <!-- <p class="mb-0">Please mention this order number in any communication with PCBFABExpress.</p> -->
            <p *ngIf="!commonService.commonMainObj.isNotAuthChecked" class="mb-0" style="font-size: 1.1rem;">You can now track the progress of your <a class="text-lgh-yellow cursor-pointer" target="_blank" href="{{commonService.commonMainObj.orderRedirectUrl}}"><b> Order</b></a></p>
            <p *ngIf="commonService.commonMainObj.isNotAuthChecked" class="mb-0">We have sent an email to <strong class="text-lgh-yellow">{{commonService.commonMainObj.purchasingPersonDetails.firstName}} {{commonService.commonMainObj.purchasingPersonDetails.lastName}},  <span style="text-decoration: underline;">{{commonService.commonMainObj.purchasingPersonDetails.email}}</span></strong> with a link to fill payment info.</p>
            <p class="mb-0">Please be sure to review our <a class="cursor-pointer text-primary" target="_blank" href="{{apiService.Terms_And_Conditions_URL}}">Terms & Conditions</a></p>
            
        </div>
        <div class="text-center" *ngIf="commonService.commonMainObj.orderPlacedData.pendingPaymentMessage">
          <div class="text-danger">{{commonService.commonMainObj.orderPlacedData.pendingPaymentMessage1.split(commonService.commonMainObj.orderPlacedData.orderNumber)[0]}} <b>{{commonService.commonMainObj.orderPlacedData.orderNumber}}</b> {{commonService.commonMainObj.orderPlacedData.pendingPaymentMessage1.split(commonService.commonMainObj.orderPlacedData.orderNumber)[1]}}</div>
          <p class="mb-0" style="font-size: 1.1rem;">You can now track the progress of your <a class="text-lgh-yellow cursor-pointer" target="_blank" href="{{commonService.commonMainObj.orderRedirectUrl}}"><b> Order</b></a></p>
          
          <div *ngIf="!updatePurchesCheck" class="mt-3">{{commonService.commonMainObj.orderPlacedData.pendingPaymentMessage2}}</div>
          <div *ngIf="!updatePurchesCheck">{{commonService.commonMainObj.orderPlacedData.pendingPaymentMessage3}}</div>

          <div *ngIf="updatePurchesCheck" class="mt-3">We have sent email to <b> {{commonService.commonMainObj.purchasingPersonDetails.firstName}} {{commonService.commonMainObj.purchasingPersonDetails.lastName}} </b> <a href="{{commonService.commonMainObj.purchasingPersonDetails.email}}">{{commonService.commonMainObj.purchasingPersonDetails.email}}</a> with link to fill payment info.</div>
          <div *ngIf="updatePurchesCheck">Your note to <b>{{commonService.commonMainObj.purchasingPersonDetails.firstName}}</b>: {{commonService.commonMainObj.purchasingPersonDetails.remarks?commonService.commonMainObj.purchasingPersonDetails.remarks:"NA"}}</div>
          
          <p class="mb-0" style="font-size: 1.1rem;"><span class="ofp-link cursor-pointer" style="color: var(--bs-link-color)!important;" (click)="gotWrongPersonMail(gotWrongPersonPayment)">{{commonService.commonMainObj.orderPlacedData.pendingPaymentResendMailLinkLabel}}</span></p>
        </div>
        <!-- <div class="text-center" *ngIf="commonService.commonMainObj.orderPlacedData.pendingPaymentResendMailLinkLabel">
          <p class="text-lgh-yellow cursor-pointer" style="font-size: 1.1rem;" (click)="updatePurchesingPerson(updatePurchesModal)"><b>{{commonService.commonMainObj.orderPlacedData.pendingPaymentResendMailLinkLabel}}</b></p>
        </div> -->
        <div class="mt-5">
            <div class="fs-5 fw-bolder mb-2">Please note that your order typically progresses through following status codes:</div>
            <p>Status Codes are only updated between 9 AM and 5 PM Pacific Time, Monday through Friday.</p>
            <div class="px-3">
                <ul>
                    <li>Order Received, Awaiting Files: You have placed an order online and we are waiting for files.</li>
                    <li>Order Received, Evaluating Files: Our Engineers are Evaluating your order and files to see if they comply with our Specification. This sometimes takes 24 hours.</li>
                    <li>Order In Process: Your order is in manufacturing.</li>
                    <li>Shipped: Your order has shipped.</li>
                </ul>
            </div>
        </div>
        <div class="mt-3">
            <div class="fs-5 fw-bolder mb-2">Please update your notification preferences for this project as required</div>
            <div class="px-3">
                <ul class="list-type-number">
                    <li class="p-0">As we process your order, we may need to reach someone in your organization for specific events.</li>
                    <li class="p-0">The following notification list will be used to send out alerts to relevant roles as the order is being processed.</li>
                    <li class="p-0">You can add any number of people to any role.</li>
                </ul>
            </div>
        </div>
        <div class="mt-3">
            <div class="fs-5 fw-bolder mb-2">Examples</div>
            <div class="px-3">
                <ul>
                    <li>If there is an engineering on-hold, alert will be sent to people with primary, PCB desinger and engineer roles.</li>
                    <li>If there is a shipping issue, alert will be sent to primary and shipping roles.</li>
                    <li>If there is an issue with credit card processing, alert will be sent your primary and billing roles.</li>
                    <p>(People in primary role are always alerted and at least one person has the primary role)</p>
                </ul>
            </div>
        </div>
        <div class="mt-4">
            <!-- TABLE START -->
        
        <table style="max-width:100%; overflow-x:scroll;">
            <thead class=" ">
              <tr>
                <!-- <th class="ion-text-left">
                  <input type="checkbox" name="select" (change)="selectAll($event);" id="selAll" value="check"/><br>select all
                </th> -->
                <th class="text-center">Email ID</th>
                <th class="text-center">First Name</th>
                <th class="text-center">Last Name</th>
                <th class="text-center">Phone#</th>
                <th class="text-center">Primary</th>
                <th class="text-center">PCB Designer</th>
                <th class="text-center">Engineer</th>
                <th class="text-center">Shipping</th>
                <th class="text-center">Billing</th>
                <th class="text-center">Quality Control</th>
                <th class="text-center">Available 24/7</th>
                <th class="text-center">Do Not Disturb </th>
                <th class="text-center">Share Project</th>
                <!-- <th >Action</th> -->
              </tr>
            </thead>
  
            <tbody>
              <tr *ngFor="let notificationList of commonService.commonMainObj.notificationData; let i = index">
                  <td style="width:20%; text-align: left;">
                      <input [(ngModel)]="notificationList.email" class="table-input" type="text" value="{{notificationList.email}}" id=email{{i}} required/>
                  </td>
                  <td>
                      <input [(ngModel)]="notificationList.firstNmae" class="table-input" type="text" name="{{notificationList.firstNmae}}" id=fName{{i}} required/>
                  </td>
                  <td>
                      <input [(ngModel)]="notificationList.lastName" class="table-input" type="text" name="{{notificationList.lastName}}" id=lName{{i}} required/>
                  </td>
                  <td>
                    <input [(ngModel)]="notificationList.phone" class="table-input" type="text" name="{{notificationList.phone}}" id=phoneNo{{i}} required/>
                  </td>
                  <td>
                    <input type="checkbox" slot="end" id="PrimCHECK-{{i}}" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.primary" value="{{notificationList.primary}}" (ngModelChange)="primaryChange($event,commonService.commonMainObj.notificationData.length, i)" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.designer" value="{{notificationList.designer}}" (ngModelChange)="notificationList.designer = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.engineer" value="{{notificationList.engineer}}" (ngModelChange)="notificationList.engineer = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.shipping" value="{{notificationList.shipping}}" (ngModelChange)="notificationList.shipping = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.billing" value="{{notificationList.billing}}" (ngModelChange)="notificationList.billing = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.qualityCtrl" value="{{notificationList.qualityCtrl}}" (ngModelChange)="notificationList.qualityCtrl = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.twentyFourHrs" value="{{notificationList.twentyFourHrs}}" (ngModelChange)="notificationList.twentyFourHrs = $event ? 1 : 0" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" [(ngModel)]="notificationList.dnd" value="{{notificationList.dnd}}" (ngModelChange)="dndChange($event,commonService.commonMainObj.notificationData.length, i)" />
                  </td>
                  <td>
                    <input type="checkbox" slot="end" class="DNDCHECK-{{i}}" [(ngModel)]="notificationList.shareProject" value="{{notificationList.shareProject}}" (ngModelChange)="notificationList.shareProject = $event ? 1 : 0" />
                  </td>
                  <td *ngIf="notificationList.newLine">
                    <span class="fa fa-trash fs-2 text-danger" (click)="deleteFieldValue(i)"></span>
                    <!-- <button class="btn btn-default" *ngIf="notificationList.newLine"  type="button" (click)="deleteFieldValue(i)"><img src="assets/img/trash.png" alt="trash" ></button> -->
                  </td>
              </tr>
              <tr>
                <!-- <td colspan="2" class="text-right"><b>Add more contacts</b> <span class="border border-radius fa fa-plus m-1 p-2 fa fa-plus" (click)="addFieldValue()" ></span></td> -->
                <td colspan="7">
                  <a style="text-decoration: none;color: #000;" (click)="addFieldValue()"><button strong class="btn btn-custom"><b>Add more contacts</b></button> </a>
                </td>
                <td colspan="6" class="text-right">
                    <!-- (click)="updateFieldValue()" -->
                  <button size="medium" strong  class="btn btn-custom" (click)="updateFieldValue()"><b>Update notification</b></button>
                </td>
              </tr>
            </tbody>
          </table> 
          <!-- TABLE END -->
        </div>
        <div class="mt-5 mb-2 text-center">
          <button type="button" class="btn btn-custom" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Back to Home</b>
          </button>
        </div>
    </div>
    <!-- <div class="container border mt-5" style="margin-bottom: 10rem;" *ngIf="quoteSave">
        <div class="fs-1 fw-bolder text-center text-lgh-yellow pt-5 mb-4"> Your Quote is successfully saved!</div>
        <div class="text-center mb-5">
            <p>Your R number is <span class="text-lgh-yellow"> <b> {{commonService.commonMainObj.rNumber}}, </b> to access to your saved quote please use this <a class="text-lgh-yellow cursor-pointer text-decoration-underline" target="_blank" href="{{redirectUrl}}"><b> Link</b></a></span>.</p>
        </div>
    </div> -->
</div>

<ng-template #gotWrongPersonPayment let-modal class="auto-mapping-modal">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Update Purchasing Person Details</h4>
    <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true" class="modal-crose">×</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- <iframe id="via_in_pad_frame" [src]="urlWrongPerson"></iframe> -->
    <div class="">
      <form [formGroup]="unAuthorizedUpdateForm">
      <div class="row g-2">
          <div class="col-md">
              <div class="">
                  <label for="not_auth_first_name">First name</label>
                  <input [(ngModel)]="updatePurchesFname"  type="text" class="form-control update-input" id="not_auth_first_name" #notAuthFirstName formControlName="unAuthFirstName" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_first_name')" placeholder="First Name">
              </div>
              <div class="validation-errors mb-2">
                  <ng-container *ngFor="let validation of not_auth_validation_messages.unAuthFirstName">
                    <div class="error-message" *ngIf="unAuthorizedUpdateForm.get('unAuthFirstName')?.hasError(validation.type) && (unAuthorizedUpdateForm.get('unAuthFirstName')?.dirty || unAuthorizedUpdateForm.get('unAuthFirstName')?.touched)">
                      {{ validation.message }}
                    </div>
                  </ng-container>
              </div>
          </div>
          <div class="col-md">
              <div class="">
                  <label for="not_auth_last_name">Last name</label>
                  <input [(ngModel)]="updatePurchesLname"  type="text" class="form-control update-input" id="not_auth_last_name" #notAuthLastName formControlName="unAuthLasttName" autocomplete="off" placeholder="Last Name">
              </div>
              <div class="validation-errors mb-2">
                  <ng-container *ngFor="let validation of not_auth_validation_messages.unAuthLasttName">
                    <div class="error-message" *ngIf="unAuthorizedUpdateForm.get('unAuthLasttName')?.hasError(validation.type) && (unAuthorizedUpdateForm.get('unAuthLasttName')?.dirty || unAuthorizedUpdateForm.get('unAuthLasttName')?.touched)">
                      {{ validation.message }}
                    </div>
                  </ng-container>
              </div>
          </div>
      </div>
      <div class="mt-2">
          <label for="not_auth_email">Email</label>
          <input [(ngModel)]="updatePurchesEmail"  type="text" class="form-control update-input" id="not_auth_email" #notAuthEmail formControlName="unAuthEmail" autocomplete="off" required (keyup)="commonService.removeRedBorder('not_auth_email'); validateUnauthDomain()" placeholder="Email">
      </div>
      <div class="validation-errors mb-2" *ngIf="!unauthEmailisValid">
          <ng-container *ngFor="let validation of not_auth_validation_messages.unAuthEmail">
            <div class="error-message" *ngIf="unAuthorizedUpdateForm.get('unAuthEmail')?.hasError(validation.type) && (unAuthorizedUpdateForm.get('unAuthEmail')?.dirty || unAuthorizedUpdateForm.get('unAuthEmail')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
      </div>
      <p class="validation-errors mb-2 error-message" *ngIf="unauthEmailisValid && unauthDomain">{{commonService.commonMainObj.invalidEmailErrorMsg}}</p>
      <div class="mt-2">
          <label for="not_auth_remark">Any remarks to your purchasing person</label>
          <textarea [(ngModel)]="updatePurchesRemarks" rows="3" class="form-control" id="not_auth_remark" #notAuthRemark formControlName="unAuthRemark" autocomplete="off"  placeholder="Remarks"></textarea>
      </div>
      <!-- <div class="validation-errors mb-2">
          <ng-container *ngFor="let validation of not_auth_validation_messages.unAuthRemark">
            <div class="error-message" *ngIf="unAuthorizedUpdateForm.get('unAuthRemark')?.hasError(validation.type) && (unAuthorizedUpdateForm.get('unAuthRemark')?.dirty || unAuthorizedUpdateForm.get('unAuthRemark')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
      </div> -->
  </form>
  </div>
  </div>
  <div class="modal-footer text-center" style="display: block;">
    <button type="button" class="btn btn-custom" [disabled]="!unAuthorizedUpdateForm.valid" (click)="updateResendEmail()"><b>Update & Resend Email</b></button>
  </div>
</ng-template>
<app-footer></app-footer>